module.exports = __webpack_public_path__ + "img/8.9fe23549.png";